import React from 'react';
import BasicSectionCard from './BasicSectionCard';
import {
  SpotlightCommunityImpactBox,
  SpotlightDifferentiatorsBox,
  SpotlightFreshnessActivityBox,
  SpotlightLocalRelevanceBox,
  SpotlightThisWeekBox,
} from '../../listingPage/widgets/community/SpotlightHighlightBoxComponents';

function formatDisplayDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

function normalizeList(rawItems, fallbackItems, maxItems = 6) {
  if (Array.isArray(rawItems)) {
    const next = rawItems
      .map((item) => {
        if (typeof item === 'string') return item.trim();
        if (item && typeof item === 'object') {
          return (item.title || item.name || item.label || item.description || '').toString().trim();
        }
        return '';
      })
      .filter(Boolean)
      .slice(0, maxItems);

    if (next.length > 0) {
      return next;
    }
  }

  return fallbackItems.slice(0, maxItems);
}

function formatShortDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

function normalizeWeekItems(rawItems) {
  if (Array.isArray(rawItems) && rawItems.length > 0) {
    const next = rawItems
      .map((item) => {
        if (!item || typeof item !== 'object') return null;
        const title = (item.title || item.name || '').toString().trim();
        const when = (item.when || item.timeRange || item.detail || '').toString().trim();
        const date = formatShortDate(item.startAt || item.startsAt || item.date);
        if (!title) return null;
        return {
          title,
          when,
          date,
        };
      })
      .filter(Boolean)
      .slice(0, 3);

    if (next.length > 0) {
      return next;
    }
  }

  return [
    { title: 'Live Acoustic Night', when: 'Fri, 6:00 - 8:00 PM', date: 'May 16' },
    { title: 'Latte Art Workshop', when: 'Sun, 10:00 - 11:30 AM', date: 'May 18' },
    { title: 'Trivia Night', when: 'Tue, 7:00 - 9:00 PM', date: 'May 20' },
  ];
}

function BasicSpotlightModulesCard({
  listing,
}) {
  const communityItems = normalizeList(listing?.communityHighlights || listing?.community?.activities, [
    'Hosted "Coffee & Kids" event for local families',
    'Sponsor of Roswell Roots Festival',
    'Monthly donations to North Fulton Community Charities',
    'Partnered with local school entrepreneur programs',
  ]);

  const differentiatorItems = normalizeList(listing?.differentiators || listing?.uniqueSellingPoints || listing?.highlightBullets, [
    'Locally owned and operated by nearby residents',
    'House-made signature options and seasonal menus',
    'Sourced from ethical, sustainable partners',
    'Community-first culture with a neighborhood vibe',
  ]);

  const localRelevanceItems = normalizeList(
    listing?.localRelevanceHighlights || listing?.localRelevance || listing?.localContextHighlights,
    [
      `Just steps away from the heart of ${listing?.city || 'town'}.`,
      'A perfect stop before or after local events.',
      'A popular meetup spot for neighborhood groups.',
    ],
  );

  const weekItems = normalizeWeekItems(listing?.weeklyMoments || listing?.events || listing?.upcomingEvents);

  const freshnessItems = [
    `Last verified: ${formatDisplayDate(listing?.lastVerifiedAt || listing?.updatedAt) || 'Recently'}`,
    `Last offer update: ${formatDisplayDate(listing?.offerUpdatedAt || listing?.updatedAt) || 'Recently'}`,
    `${listing?.newPhotosCount || 0} new photos added recently`,
    `${listing?.communityActivityCount || 0} community activities this month`,
  ];

  return (
    <BasicSectionCard id="spotlight" title="Spotlight Modules">
      <div id="spotlight-ModuleGrid" className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <article id="spotlight-CommunityImpact" className="rounded-lg border p-4" style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--surface)' }}>
          <SpotlightCommunityImpactBox city={listing?.city} items={communityItems} />
        </article>

        <article id="spotlight-Differentiators" className="rounded-lg border p-4" style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--surface)' }}>
          <SpotlightDifferentiatorsBox items={differentiatorItems} />
        </article>

        <article id="spotlight-ThisWeek" className="rounded-lg border p-4" style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--surface)' }}>
          <SpotlightThisWeekBox weekItems={weekItems} />
        </article>

        <article id="spotlight-LocalRelevance" className="rounded-lg border p-4" style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--surface)' }}>
          <SpotlightLocalRelevanceBox items={localRelevanceItems} />
        </article>

        <article id="spotlight-FreshnessActivity" className="rounded-lg border p-4" style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--surface)' }}>
          <SpotlightFreshnessActivityBox items={freshnessItems} />
        </article>
      </div>
    </BasicSectionCard>
  );
}

export default BasicSpotlightModulesCard;
